import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Button, IconButton } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";

const Acessibilidade = () => {
  const theme = useTheme();
  const [fontSize, setFontSize] = useState(16); // Tamanho base da fonte

  // Função para aumentar o tamanho da fonte
  const aumentarTexto = () => {
    if (fontSize < 24) {
      setFontSize((prev) => prev + 2);
    }
  };

  // Função para diminuir o tamanho da fonte
  const diminuirTexto = () => {
    if (fontSize > 12) {
      setFontSize((prev) => prev - 2);
    }
  };

  // Aplica o tamanho da fonte dinamicamente no corpo do documento
  React.useEffect(() => {
    document.body.style.fontSize = `${fontSize}px`;
  }, [fontSize]);

  return (
    <Box
      style={{
        display: "flex",
        height: "6vh",
        justifyContent: "space-between",
        padding: "8px 16px",
        backgroundColor: theme.palette.primary.main,
      }}
    >
      <Box style={{ display: "flex", gap: "6px", alignItems: "center" }}>
        <IconButton
          href="https://www.instagram.com/camaraserracaiada/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "white", // Cor do ícone
          }}
        >
          <InstagramIcon />
        </IconButton>
        <IconButton
          href="www.facebook.com/camaraserracaiada"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "white", // Cor do ícone
          }}
        >
          <FacebookIcon />
        </IconButton>
        <IconButton
          href="https://www.youtube.com/channel/UCqb5teVCtj0MjyV7Z3_2UqQ"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "white", // Cor do ícone
          }}
        >
          <YouTubeIcon />
        </IconButton>
      </Box>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          onClick={() => (window.location.href = "/mapadosite")}
          style={{
            background: "none",
            border: "none",
            color: "white",
            cursor: "pointer",
            padding: "8px",
            fontSize: "clamp(14px, 2vw, 18px)",
          }}
        >
          🗺️ Mapa do site
        </button>
        <button
          onClick={() => window.open("https://cmserracaiadarn.transparencia.topsolutionsrn.com.br", "_blank")}
          style={{
            background: "none",
            border: "none",
            color: "white",
            cursor: "pointer",
            padding: "8px",
            fontSize: "clamp(14px, 2vw, 18px)",
          }}
        >
          📋 Transparência
        </button>
      </div>
    </Box>
  );
};

export default Acessibilidade;
